import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { IMapGeometry, IMapGeometryWicket } from "~app/common/components/map/map.settings";

@Injectable({
    providedIn: "root"
})
export class TransportforetagRedigeraService {
    editTransportomrade$ = new Subject<IMapGeometryWicket>();
    deleteTransportomrade$ = new Subject<IMapGeometry>();

    editTransportomrade(geometry: IMapGeometryWicket) {
        this.editTransportomrade$.next(geometry);

    }

    deleteTransportomrade(geometry: IMapGeometry) {
        this.deleteTransportomrade$.next(geometry);
    }
}
